import { PersonSearchSelect } from '~/pages/person/components/person-search-select';
import { useCompetitionQuery } from '~/pages/competition/queries';
import { Schema } from './register-lifter-form-schema';
import { useFormContext } from 'react-hook-form';
import { useParams } from '~/hooks/useParams';
import { idParamSchema } from '~/schemas';

export function RegisterLifterPersonSearch() {
  const { formState, setValue, trigger, register } = useFormContext<Schema>();
  const { id } = useParams(idParamSchema.parse);
  const { data } = useCompetitionQuery(id);

  return (
    <PersonSearchSelect
      {...register('person_id')}
      onChange={([, personId]) => {
        setValue('person_id', Number(personId), { shouldDirty: true });
        trigger('person_id');
      }}
      query={{ can_register_for_competition: id }}
      placeholder="Sök efter licensierad lyftare..."
      disableWhenCannotRegister
      formState={formState}
      disabled={!data}
      name="person_id"
    />
  );
}
